<ng-template appAttachTo="header-title">
  {{ 'transportDocuments.title' | transloco }}
</ng-template>

<div class="pt-3">

  <div class="bg-white p-3 shadow-sm rounded-2">
    <app-documents-search-bar [loading]="loading$ | async"
                              [viewSettings]="viewSettings">
    </app-documents-search-bar>
  </div>

  <div class="my-3 bg-white shadow-sm rounded-2">
    <app-document-search-results-header [viewSettings]="viewSettings"
                                        (exportDocumentsClicked)="exportDocuments()"
                                        (importDocumentsClicked)="showImportDocuments()">
    </app-document-search-results-header>
    <app-document-search-results [searchResponse]="searchResult$ | async"
                                 [viewMode]="viewSettings.viewMode$ | async"
                                 [displayedColumns]="viewSettings.columns$ | async"
                                 (openPdfClicked)="openPDF($event)"
                                 (acceptDeliveryClicked)="acceptDelivery($event)"
                                 (vsEndReached)="onVsEndReached($event)">
    </app-document-search-results>

    <app-loader [loading]="loading$ | async"></app-loader>
  </div>
</div>
